/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssessmentStatusEnum } from './AssessmentStatusEnum';
import {
  AssessmentStatusEnumFromJSON,
  AssessmentStatusEnumFromJSONTyped,
  AssessmentStatusEnumToJSON,
} from './AssessmentStatusEnum';

/**
 *
 * @export
 * @interface AssessmentShallow
 */
export interface AssessmentShallow {
  /**
   *
   * @type {number}
   * @memberof AssessmentShallow
   */
  readonly id: number;
  /**
   *
   * @type {Date}
   * @memberof AssessmentShallow
   */
  timestamp?: Date;
  /**
   *
   * @type {AssessmentStatusEnum}
   * @memberof AssessmentShallow
   */
  status?: AssessmentStatusEnum;
}

/**
 * Check if a given object implements the AssessmentShallow interface.
 */
export function instanceOfAssessmentShallow(value: object): value is AssessmentShallow {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function AssessmentShallowFromJSON(json: any): AssessmentShallow {
  return AssessmentShallowFromJSONTyped(json, false);
}

export function AssessmentShallowFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentShallow {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    status: json['status'] == null ? undefined : AssessmentStatusEnumFromJSON(json['status']),
  };
}

export function AssessmentShallowToJSON(value?: Omit<AssessmentShallow, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    status: AssessmentStatusEnumToJSON(value['status']),
  };
}
